import React, { useContext, useEffect, useState } from "react";
import "./Elements.scss";
import { SquareContext } from "../../SquareContext";
import { ShapeContext } from "../../ShapeContext";
import cx from "classnames";
import { Steps, Step } from "react-step-builder";
import { useMediaQuery } from "react-responsive";
import arrow from "../../assets/arrowCards.svg";
import arrowred from "../../assets/plusred.svg";

function Elements(props) {
  const {
    cartItems,
    shapeItems,
    shape,
    shapeUnits,
    shapeUnits2,
    shapeUnits3,
    shapeUnits4,
    shapeUnits5,
    shapeUnits6,
    shapeUnits7,
    shapeUnits8,
    shapeUnits9,
    listShape,
    unit,
    shapePortion,
    shapeEdge,
    shapeEdge2,
    shapeEdge3,
    inVal,
    inVal2,
    inVal3,
    inVal4,
    inVal5,
    inVal6,
    inVal7,
    inVal8,
    inVal9,
    inVal10,
    getEle,
    result,
    setResult,
    setResultTotal,cart,
    linearArea, setLinearArea, resultTotal
  } = useContext(SquareContext);
  const {
    box1c,
    box2c,
    box3c,
    box4c,
    box1r,
    box2r,
    box3r,
    box4r,
    box1l,
    box2l,
    box3l,
    box4l,
    box1t,
    box2t,
    box3t,
    box4t,
    box1is,
    box2is,
    box3is,
    box4is, 
  } = useContext(ShapeContext);

  const unity = shapeUnits.length + shapeUnits2.length + shapeUnits7.length;
  const unity2 = shapeUnits3.length + shapeUnits4.length + shapeUnits8.length;
  const unity3 = shapeUnits5.length + shapeUnits6.length + shapeUnits9.length;

 const resultStart =
    inVal + inVal2 + inVal3 + inVal4 + inVal5 + inVal6 + inVal7 + inVal8 +  inVal9 + inVal10
    

    // shape.find((obj) => obj.id === 6)
    useEffect(() => {
    if(shape.find((obj) => obj.id === 1)){
      setLinearArea((parseFloat(inVal) + parseFloat(inVal2) ) * 2)
    }
    else if (shape.find((obj) => obj.id === 2)){
      setLinearArea( (parseFloat(inVal2) * 2) + ((parseFloat(inVal3) + parseFloat(inVal4)) *2 )  )
    }
    else if (shape.find((obj) => obj.id === 3)){
      setLinearArea( ((parseFloat(inVal2) * 2) + (parseFloat(inVal3)  *2 + 
      parseFloat(inVal4) +(parseFloat(inVal4) - parseFloat(inVal)))) + 
      (parseFloat(inVal5) * 2 + parseFloat(inVal6) + 
      (parseFloat(inVal6) - parseFloat(inVal))) )
    }
    else if (shape.find((obj) => obj.id === 4)){
      setLinearArea( ((parseFloat(inVal2) * 2) + (parseFloat(inVal3)  *2 + 
      parseFloat(inVal4) +(parseFloat(inVal4) - parseFloat(inVal)))) + 
      (parseFloat(inVal5) * 2 + parseFloat(inVal6) + 
      (parseFloat(inVal6) - parseFloat(inVal))) + ((parseFloat(inVal7) + parseFloat(inVal8)) * 2) )
    }

    else if (shape.find((obj) => obj.id === 5)){
      setLinearArea( (parseFloat(inVal2) * 2) + ((parseFloat(inVal3) + parseFloat(inVal4)) *2 ) + ((parseFloat(inVal7) + parseFloat(inVal8)) * 2)  )
    }

    else if (shape.find((obj) => obj.id === 6)){
      setLinearArea( ((parseFloat(inVal2) * 2) + (parseFloat(inVal3)  *2 + 
      parseFloat(inVal4) +(parseFloat(inVal4) - parseFloat(inVal) - parseFloat(inVal7)))) + 
      (parseFloat(inVal5) * 2 + parseFloat(inVal6) + 
      (parseFloat(inVal6) - parseFloat(inVal))) + ( parseFloat(inVal7) + (parseFloat(inVal8) * 2))  )
    }
    else if (shape.find((obj) => obj.id === 7)){
      setLinearArea( ((parseFloat(inVal2) * 2) + (parseFloat(inVal3)  *2 + 
      parseFloat(inVal4) +(parseFloat(inVal4) - parseFloat(inVal) - parseFloat(inVal7)))) + 
      (parseFloat(inVal5) * 2 + parseFloat(inVal6) + 
      (parseFloat(inVal6) - parseFloat(inVal))) + ( parseFloat(inVal7) + (parseFloat(inVal8) * 2)) + ((parseFloat(inVal9) + parseFloat(inVal10)) *2)  )
   }else if(shape.find((obj) => obj.id === 8)){
    setLinearArea(((parseFloat(inVal) + parseFloat(inVal2) ) * 2) + ((parseFloat(inVal7) + parseFloat(inVal8) ) * 2) )
  }
    
    },[inVal, inVal10, inVal2, inVal3, inVal4, inVal5, inVal6, inVal7, inVal8, inVal9, setLinearArea, shape])



  useEffect(() => {
    setResult(Math.floor((
      //---------------center--------------------
      (box2c === true && inVal !== 0 ? parseFloat(inVal) : 0) +
        (box3c === true && inVal2 !== 0 ? parseFloat(inVal2) : 0) +
        (box1c === true && inVal2 !== 0 ? parseFloat(inVal2) : 0) +
        (box4c === true && inVal !== 0 ? parseFloat(inVal) : 0) +
        //---------------right--------------------
        (box3r === true && inVal3 !== 0 ? parseFloat(inVal3) : 0) +
        (box1r === true && inVal3 !== 0 ? parseFloat(inVal3) : 0) +
        (box4r === true && inVal4 !== 0 ? parseFloat(inVal4) : 0) +
         (box2r === true && inVal4 !== 0 && inVal !== 0 
        // (shape.find((obj) => obj.id === 6) || shape.find((obj) => obj.id === 7)  ?  inVal7 !== 0 : inVal7 === 0)
          ? (parseFloat(inVal4) - parseFloat(inVal) - 
          (shape.find((obj) => obj.id === 6) || shape.find((obj) => obj.id === 7) ? parseFloat(inVal7) : 0 ))
          : 0) +
        //--------------left----------------------
        (box2l === true && inVal6 !== 0 ? parseFloat(inVal6) : 0) +
        (box3l === true && inVal5 !== 0 ? parseFloat(inVal5) : 0) +
        (box1l === true && inVal5 !== 0 ? parseFloat(inVal5) : 0) +
        (box4l === true && inVal6 !== 0 && inVal !== 0
          ? parseFloat(inVal6) - parseFloat(inVal)
          : 0) +
        //---------------top----------------------
        (box2t === true && inVal7 !== 0 ? parseFloat(inVal7) : 0) +
        (box3t === true && inVal8 !== 0 ? parseFloat(inVal8) : 0) +
        (box1t === true && inVal8 !== 0 ? parseFloat(inVal8) : 0) +
        (box4t === true && inVal7 !== 0 ? parseFloat(inVal7) : 0) +
    
        //---------------top-island---------------------
        (box2is === true && inVal9 !== 0 ? parseFloat(inVal9) : 0) +
        (box3is === true && inVal10 !== 0 ? parseFloat(inVal10) : 0) +
        (box1is === true && inVal10 !== 0 ? parseFloat(inVal10) : 0) +
        (box4is === true && inVal9 !== 0 ? parseFloat(inVal9) : 0) 

    ) *100) /100);
  }, [
    inVal,
    inVal2,
    inVal3,
    inVal4,
    inVal5,
    inVal6,
    inVal7,
    inVal8,
    box2c,
    box3c,
    box1c,
    box4c,
    box1r,
    box2r,
    box3r,
    box4r,
    box1l,
    box2l,
    box3l,
    box4l,
    box1t,
    box2t,
    box3t,
    box4t,
    box1is,
    box2is,
    box3is,
    box4is, 
    inVal9,
    inVal10,
  ]);



  useEffect(() => {
    setResultTotal(
      (inVal !== "" && inVal2 !== ""
        ? parseFloat(inVal) * parseFloat(inVal2)
        : 0) +
        (inVal3 !== "" && inVal4 !== ""
          ? parseFloat(inVal3) * parseFloat(inVal4)
          : 0) +
        (inVal5 !== "" && inVal6 !== ""
          ? parseFloat(inVal5) * parseFloat(inVal6)
          : 0) +
        (inVal7 !== "" && inVal8 !== ""
          ? parseFloat(inVal7) * parseFloat(inVal8)
          : 0) +
        (inVal9 !== "" && inVal10 !== ""
          ? parseFloat(inVal9) * parseFloat(inVal10)
          : 0)
    );
  }, [inVal, inVal2, inVal3, inVal4, inVal5, inVal6, inVal7, inVal8, inVal9,inVal10]);




  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const [isShowed, setIsShowed] = useState(false);

  function handleClick() {
    if (!isShowed) {
      setIsShowed(true);
    } else {
      setIsShowed(false);
    }
  }

  // const wewe = Object.keys(cart[0]['thicknesses'])
 




  return (
    <>
      {isTabletOrMobile ? (
        <div className="card-ele">
          <div className="forHeader-ele">
            <div className="forHeader-margin-ele">
              <h3>Summary</h3>
              <img
                src={!isShowed ? arrow : arrowred}
                alt="arrow"
                onClick={handleClick}
              />
            </div>
          </div>
          {isShowed && <div className="elements">
          {/* ************************************Item1------------------Item1*************************************/}
          {cartItems[0] && (
            <div className="el-left">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness--1-------------------------------------------------- */}
              {unity !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                    {/* {shapeUnits.length !== 0 && shapeUnits[0]}
                    {shapeUnits2.length !== 0 && shapeUnits2[0]}
                    {shapeUnits7.length !== 0 && shapeUnits7[0]} */}
                    <p> {Object.keys(cart[0]['thicknesses'])[0] === "12mm" ? shapeUnits.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[0] : ""}</p>
                    <p>{Object.keys(cart[0]['thicknesses'])[0] === "20mm" ? shapeUnits2.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[0] : shapeUnits2.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[1] }</p>
                    <p>                    {Object.keys(cart[0]['thicknesses'])[0] === "20mm" ? shapeUnits7.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[1] : shapeUnits7.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[2] }</p>

                  </div>
                </div>
              )}
              {unity !== 0 && <hr className="ele-line3"></hr>}
              {/* ---------------------------------Measurements----1------------------------------------------------ */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing-------1--------------------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 || result === isNaN ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions 1---------------------------------------------------- */}
              {resultTotal ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? 0 : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? 0 : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? 0 : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? 0 : `${inVal8} x ${inVal7}`}
                </div>
              )}
               {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? 0 : `${inVal10} x ${inVal9}`}
                </div>
              )}
            

              {resultTotal !== 0 && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge---------------1------------------------------------- */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
          {/* ************************************Item2------------------Item2*************************************/}
          {cartItems[1] && (
            <div className="el-middle">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness-----------2----------------------------------------- */}
              {unity2 !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                    {/* {shapeUnits3.length !== 0 && shapeUnits3[0]}
                    {shapeUnits4.length !== 0 && shapeUnits4[0]}
                    {shapeUnits8.length !== 0 && shapeUnits8[0]} */}

                   <p> {Object.keys(cart[1]['thicknesses'])[0] === "12mm" ? shapeUnits3.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[0] : ""}</p>
                    <p>{Object.keys(cart[1]['thicknesses'])[0] === "20mm" ? shapeUnits4.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[0] : shapeUnits4.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[1] }</p>
                   <p> {Object.keys(cart[1]['thicknesses'])[0] === "20mm" ? shapeUnits8.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[1] : shapeUnits8.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[2] }</p>

                  </div>
                </div>
              )}
              {unity2 !== 0 && <hr className="ele-line3"></hr>}

              {/* ---------------------------------Measurements---------------2------------------------------------- */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing--------------2-------------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions-------------2--------------------------------------- */}
              {resultTotal !== "" ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? 0 : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? 0 : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? 0 : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? 0 : `${inVal8} x ${inVal7}`}
                </div>
              )}
                {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? 0 : `${inVal10} x ${inVal9}`}
                </div>
              )}

              {resultTotal !== "" && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge----------------------2------------------------------ */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge2[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
          {/* ************************************Item3------------------Item3*************************************/}
          {cartItems[2] && (
            <div className="el-right">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness------------3---------------------------------------- */}
              {unity3 !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                    {/* {shapeUnits5.length !== 0 && shapeUnits5[0]}
                    {shapeUnits6.length !== 0 && shapeUnits6[0]}
                    {shapeUnits9.length !== 0 && shapeUnits9[0]} */}

                    <p>{Object.keys(cart[2]['thicknesses'])[0] === "12mm" ? shapeUnits5.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[0] : ""}</p>
                   <p> {Object.keys(cart[2]['thicknesses'])[0] === "20mm" ? shapeUnits6.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[0] : shapeUnits6.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[1] }</p>
                    <p>                    {Object.keys(cart[2]['thicknesses'])[0] === "20mm" ? shapeUnits9.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[1] : shapeUnits9.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[2] }</p>

                  </div>
                </div>
              )}
              {unity3 !== 0 && <hr className="ele-line3"></hr>}
              {/* ---------------------------------Measurements---------------3------------------------------------- */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing-------------------3--------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions----------------3------------------------------------ */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? 0 : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? 0 : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? 0 : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? 0 : `${inVal8} x ${inVal7}`}
                </div>
              )}
                {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? 0 : `${inVal10} x ${inVal9}`}
                </div>
              )}

              {resultTotal !== 0 && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge-------------------------3--------------------------- */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge3[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
        </div>}
        </div>
    
      ) : (
        <div className={props.eleclass}>
           {/* ***************************************************************************************************** */}
          {/* ***************************************************************************************************** */}
          {/* ***************************************************************************************************** */}
          {/* ***************************************************************************************************** */}
          {/* ***************************************************************************************************** */}
          {/* ************************************Item1------------------Item1*************************************/}
          {cartItems[0] && (
            <div className="el-left">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness--1-------------------------------------------------- */}
              {unity !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                    
                    <p>{Object.keys(cart[0]['thicknesses'])[0] === "12mm" ? shapeUnits.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[0] : ""}</p>
                   <p> {Object.keys(cart[0]['thicknesses'])[0] === "20mm" ? shapeUnits2.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[0] : shapeUnits2.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[1] }</p>
                    <p>{Object.keys(cart[0]['thicknesses'])[0] === "20mm" ? shapeUnits7.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[1] : shapeUnits7.length !== 0 && cart[0] !== undefined && Object.keys(cart[0]['thicknesses'])[2] }</p>
                    {/* {shapeUnits.length !== 0 && shapeUnits[0]}
                      {shapeUnits2.length !== 0 && shapeUnits2[0]}
                    {shapeUnits7.length !== 0 && shapeUnits7[0]} */}
                  </div>
                </div>
              )}
              {unity !== 0 && <hr className="ele-line3"></hr>}
              {/* ---------------------------------Measurements----1------------------------------------------------ */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing-------1--------------------------------------------- */}
              {resultTotal ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions 1---------------------------------------------------- */}
              {resultTotal ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? "" : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? "" : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? "" : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? "" : `${inVal8} x ${inVal7}`}
                </div>
              )}
                {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? "" : `${inVal10} x ${inVal9}`}
                </div>
              )}

              {resultTotal !== 0  && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge---------------1------------------------------------- */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
          {/* ************************************Item2------------------Item2*************************************/}
          {cartItems[1] && (
            <div className="el-middle">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness-----------2----------------------------------------- */}
              {unity2 !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                  {/* {shapeUnits3.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[0]}
                    {shapeUnits4.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[1]}
                    {shapeUnits8.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[2]} */}


                    <p>{Object.keys(cart[1]['thicknesses'])[0] === "12mm" ? shapeUnits3.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[0] : ""}</p>
                    <p>{Object.keys(cart[1]['thicknesses'])[0] === "20mm" ? shapeUnits4.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[0] : shapeUnits4.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[1] }</p>
                    <p>{Object.keys(cart[1]['thicknesses'])[0] === "20mm" ? shapeUnits8.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[1] : shapeUnits8.length !== 0 && cart[1] !== undefined && Object.keys(cart[1]['thicknesses'])[2] }</p>
                  </div>
                </div>
              )}
              {unity2 !== 0 && <hr className="ele-line3"></hr>}

              {/* ---------------------------------Measurements---------------2------------------------------------- */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing--------------2-------------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions-------------2--------------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? 0 : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? 0 : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? 0 : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? 0 : `${inVal8} x ${inVal7}`}
                </div>
              )}
                {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? 0 : `${inVal10} x ${inVal9}`}
                </div>
              )}

              {resultTotal !== 0 && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge----------------------2------------------------------ */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge2[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
          {/* ************************************Item3------------------Item3*************************************/}
          {cartItems[2] && (
            <div className="el-right">
              <div className="elements-p">
                <p>Elements</p>
              </div>
              <div>{shapeItems[0]}</div>
              {shapeItems.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Thickness------------3---------------------------------------- */}
              {unity3 !== 0 && (
                <div>
                  <div className="elements-p">
                    <p>Thickness</p>
                  </div>
                  <div className="thick-div">
                 


                    <p>{Object.keys(cart[2]['thicknesses'])[0] === "12mm" ? shapeUnits5.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[0] : ""}</p>
                    <p>{Object.keys(cart[2]['thicknesses'])[0] === "20mm" ? shapeUnits6.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[0] : shapeUnits6.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[1] }</p>
                    <p>                    {Object.keys(cart[2]['thicknesses'])[0] === "20mm" ? shapeUnits9.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[1] : shapeUnits9.length !== 0 && cart[2] !== undefined && Object.keys(cart[2]['thicknesses'])[2] }</p>

                  </div>
                </div>
              )}
              {unity3 !== 0 && <hr className="ele-line3"></hr>}
              {/* ---------------------------------Measurements---------------3------------------------------------- */}
              {shapePortion.length !== 0 && (
                <div className="elements-p">
                  <p>Measurement</p>
                </div>
              )}
              <div className="measure-style">{shapePortion[0]}</div>
              {shapePortion.length !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Polishing-------------------3--------------------------------- */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Polishing</p>
                </div>
              ) : (
                <div></div>
              )}
              {resultTotal === 0 ? (
                <div></div>
              ) : (
                <div className="polishing3">
                  {result}
                  {getEle}
                </div>
              )}
              {resultTotal !== 0 && <hr className="ele-line"></hr>}
              {/* ---------------------------------Dimensions----------------3------------------------------------ */}
              {resultTotal !== 0 ? (
                <div className="elements-p polish">
                  <p>Dimensions</p>
                </div>
              ) : (
                <div></div>
              )}
              {!inVal || !inVal2 ? (
                <div></div>
              ) : (
                <div className="polishing">
                  {inVal === 0 || inVal2 === 0 ? 0 : `${inVal2} x ${inVal}`}
                </div>
              )}
              {!inVal3 || !inVal4 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal3 === 0 || inVal4 === 0 ? 0 : `${inVal4} x ${inVal3}`}
                </div>
              )}
              {!inVal5 || !inVal6 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal5 === 0 || inVal6 === 0 ? 0 : `${inVal6} x ${inVal5}`}
                </div>
              )}
              {!inVal7 || !inVal8 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal7 === 0 || inVal8 === 0 ? 0 : `${inVal8} x ${inVal7}`}
                </div>
              )}
                {!inVal9 || !inVal10 ? (
                <div></div>
              ) : (
                <div className="polishing2">
                  {inVal9 === 0 || inVal10 === 0 ? 0 : `${inVal10} x ${inVal9}`}
                </div>
              )}

              {resultTotal !== 0 && <hr className="ele-line-dim"></hr>}
              {/* ---------------------------------Edge-------------------------3--------------------------- */}
              {shapeEdge.length !== 0 && (
                <div className="elements-p">
                  <p className="edge">Edge</p>
                </div>
              )}
              <div className="ele-3-edge">{shapeEdge3[0]}</div>
              {shapeEdge.length !== 0 && <hr className="ele-line"></hr>}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default Elements;
